/**
 * Currency formatter for real-time formatting (USD, no decimals)
 */
export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

/**
 * Formats a number as a currency string
 *
 * NOTE: A million is formatted as MM, because a single M is often used to represent thousands
 */
export function displayCurrency(
  amount: number,
  locale: Intl.LocalesArgument,
  notation: Intl.NumberFormatOptions['notation'] = 'compact',
  currency: Intl.NumberFormatOptions['currency'] = 'USD'
): string {
  const formattedAmt = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    notation,
  }).format(amount)

  if (formattedAmt.endsWith('M')) {
    return formattedAmt + 'M'
  }
  return formattedAmt
}
